import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Types
import { ConfigFile } from '../../../shared/types/manageCalls';

// Services
import { WebServiceCaller } from '../../services/webservice-caller/webservice-caller.service';

@Injectable()
export class ConfigService {
  private readonly wsCaller = inject(WebServiceCaller);

  configFile(): Observable<ConfigFile> {
    return this.wsCaller.getCall<ConfigFile>('appFunctions/configFile');
  }
}
